import React from 'react';

const Pay = () => {
    return (
        <div className='d-flex justify-content-center align-items-center' style={{height:'80vh'}}>
            <h3>Pay will be comming soon</h3>
        </div>
    );
};

export default Pay;